<template>
  <div class="block1200 block1620 ck-content submit-cont">
    <a-card title="核对订单">
      <!-- {{ _isMobile ? '移动端方案' : 'pc端方案' }} -->
      <a-table :columns="columns" :data-source="result" rowKey="id">
        <template slot="wordNumber" slot-scope="text">
          <span>{{ text }}字符</span>
        </template>
        <template slot="price" slot-scope="text, record">
          <span v-if="record.unitType === 'NUM'"
            >{{ record.price }}元 / {{ record.unit }}字</span
          >
          <span v-else>{{ record.price }}元 / 篇 </span>
        </template>
      </a-table>
      <a-form
        :form="couponform"
        @submit="couponSubmit"
        v-if="$store.state.check.activeObj.haveCoupon === 'Y'"
      >
        <ARow>
          <ACol :span="8">
            <a-form-item label="使用优惠券" v-bind="formItemLayout1">
              <a-input
                placeholder="请输入优惠码兑换"
                v-decorator="[
                  'id',
                  {
                    rules: [{ required: true, message: '请输入优惠码!' }],
                  },
                ]"
              />
            </a-form-item>
          </ACol>
          <ACol :span="8">
            <div style="line-height: 40px; margin-left: 20px">
              <a-button type="primary" html-type="submit"> 兑换 </a-button>
            </div>
          </ACol>
        </ARow>
      </a-form>
    </a-card>
    <a-card style="margin-top: 15px">
      <a-form :form="form" @submit="submit">
        <a-card
          title="支付方式"
          :bordered="false"
          style="width: 50%; float: left"
        >
          <a-radio-group :value="value" @change="onchange">
            <a-radio
              class="radioStyle"
              :value="'ALIPAY'"
              v-if="$store.state.check.activeObj.useAli === 'Y'"
            >
              <img
                src="../assets/images/zhifubao.png"
                height="25"
                alt=""
                style="margin-right: 8px"
              />
              <span v-if="!isMobile">支付宝支付</span>
            </a-radio>
            <a-radio
              class="radioStyle"
              :value="'WEIXIN'"
              v-if="$store.state.check.activeObj.useWx === 'Y'"
            >
              <img
                src="../assets/images/weixin.png"
                height="25"
                alt=""
                style="margin-right: 8px"
              />
              <span v-if="!isMobile">微信支付</span>
            </a-radio>
            <a-radio
              class="radioStyle"
              :value="'TMALL'"
              v-if="$store.state.check.activeObj.useTmall === 'Y'"
            >
              <img
                src="../assets/images/taobao.png"
                height="25"
                alt=""
                style="margin-right: 8px"
              />淘宝支付
            </a-radio>
          </a-radio-group>
        </a-card>
        <a-card
          title="核对金额"
          :bordered="false"
          style="width: 50%; float: right"
          :bodyStyle="{ padding: 0, position: 'relative' }"
        >
          <div class="pull-left show-money">
            <div class="OrderMoneyCalc">
              <ul>
                <li>
                  <p>订单金额</p>
                  <p>
                    ￥<span class="yj OriginMoney">{{
                      this.result[0] && this.result[0].amount
                    }}</span>
                  </p>
                </li>
                <li v-if="this.result[0] && result[0].couponPrice">
                  <p>优惠券金额</p>
                  <p class="red">
                    -￥<span class="yhje CouponMoney">{{
                      this.result[0] && this.result[0].couponPrice
                    }}</span>
                  </p>
                </li>
              </ul>
            </div>
            <div style="border-top: 1px silver dashed" v-if="!isMobile">
              <p class="money-sf">
                <!-- <span class="sf-tit">应付金额：</span><span class="shifu">￥<i class="PayRealMoney">{{ this.result[0] && this.result[0].amount }}</i></span> -->
                <span class="sf-tit">应付金额：</span>
                <span class="shifu"
                  >￥<i class="PayRealMoney">
                    {{ this.result[0] && this.result[0].cashFee }}
                  </i>
                </span>
              </p>
            </div>
          </div>
          <div style="border-top: 1px silver dashed" v-if="isMobile">
            <p class="money-sf">
              <!-- <span class="sf-tit">应付金额：</span><span class="shifu">￥<i class="PayRealMoney">{{ this.result[0] && this.result[0].amount }}</i></span> -->
              <span class="sf-tit">应付金额：</span>
              <span class="shifu"
                >￥<i class="PayRealMoney">
                  {{ this.result[0] && this.result[0].cashFee }}
                </i>
              </span>
            </p>
          </div>
          <div
            class="tmallform"
            v-if="
              $store.state.check.activeObj.useTmall === 'Y' &&
              isMobile === false && !(value === 'WEIXIN' || value === 'ALIPAY')
            "
          >
            <a-form-item label="输入订单" v-bind="formItemLayout">
              <a-input
                v-decorator="[
                  'authcode',
                  { rules: [{ required: true, message: '请输入您的订单号' }] },
                ]"
                placeholder="请输入您的订单号"
              />
            </a-form-item>
            <a-form-item label="备用订单" v-bind="formItemLayout">
              <a-input
                v-if="!isMobile"
                v-decorator="['authcode2']"
                placeholder="请输入您的订单号"
              />
            </a-form-item>
          </div>
        </a-card>
        <div style="clear: both; border-top: 1px solid #ccc; padding-top: 20px">
          <span style="color: red">论文一旦提交，不支持无理由退款！</span>
          <a-button type="primary" style="float: right" html-type="submit">
            提交支付
          </a-button>
        </div>
        <a-modal
          v-model="visible"
          :footer="null"
          :width="220"
          @ok="handleOk"
          centered
        >
          <div v-if="value === 'WEIXIN'">微信扫码支付</div>
          <div v-if="value === 'ALIPAY'">支付宝扫码支付</div>
          <div ref="qrcode">
            <a-spin />
          </div>
          <div
            class="ng-scope"
            :style="{ display: timeOut ? 'block' : 'none' }"
          >
            <div class="tranmb"></div>
            <div style="opacity: 0">{{ qrurl }}</div>
            <div class="qr-cont">
              <img src="../assets/images/error.png" />
              <p class="txt">
                二维码已过期，请 <a href="javascript:;" @click="submit">刷新</a>
              </p>
            </div>
          </div>
        </a-modal>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import { Table, Card, Radio, Form, Button, Modal, Spin, Input, Row, Col } from 'ant-design-vue'
import QRCode from 'qrcodejs2'
import { message } from 'ant-design-vue'

const columns = [
  {
    title: '文章题目',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '文章作者',
    dataIndex: 'author',
    key: 'author',
  },
  {
    title: '检测类型',
    dataIndex: 'productTypeName',
    key: 'productTypeName',
  },
  {
    title: '单价',
    scopedSlots: { customRender: 'price' },
    dataIndex: 'price',
  },
  {
    title: '内容总计',
    scopedSlots: { customRender: 'wordNumber' },
    dataIndex: 'wordNumber',
  },
];
export default {
  components: {
    ACard: Card,
    ATable: Table,
    ARadio: Radio,
    ARadioGroup: Radio.Group,
    AForm: Form,
    AFormItem: Form.Item,
    AButton: Button,
    AModal: Modal,
    ASpin: Spin,
    AInput: Input,
    ARow: Row,
    ACol: Col,
  },
  data () {
    console.log(this.$store.state.check)
    return {
      isMobile: this._isMobile(),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      formItemLayout1: {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
      },
      tradeId: this.$route.params.tradeId || undefined,
      result: [],
      columns,
      value: this.$store.state.check.activeObj.useAli === 'Y' ? 'ALIPAY' : this.$store.state.check.activeObj.useWx === 'Y' ? 'WEIXIN' : 'TMALL',
      visible: false,
      timeOut: false,
      qrurl: null,
      // couponPrice:null,
      // useCoupon:false,
      // afterConponAmount:null,
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'payform' });
    this.couponform = this.$form.createForm(this, { name: 'couponform' })
  },
  created () {
    if (this.tradeId) {
      this.$store.dispatch('check/getTradeById', {
        payload: {
          tradeId: this.tradeId,
        },
        callback: (res) => {
          this.result = [res]
        }
      })
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return !!flag;
    },
    creatQrCode () {
      const canvas = this.$refs.qrcode
      new QRCode(canvas, {
        width: 170,
        height: 170, // 高度
        text: this.qrurl // 二维码内容
      })
      setTimeout(() => this.timeOut = true, 60000 * 3)
      setTimeout(this.checkPay, 2000)
    },
    handleOk () {
      this.visible = false
    },
    onchange (e) {
      this.value = e.target.value
    },
    checkPay () {
      if (!this.visible) return;
      this.$store.dispatch('check/requests', {
        payload: {
          tradeId: this.tradeId
        },
        callback: (res) => {
          if (res.success && res.data.payState && res.data.payState === 'PAID') {
            this.visible = false;
            window._agl && window._agl.push(['track', ['success', { t: 3 }]])
            res.data.transactionId && this.$router.push({ path: `/reports/${res.data.transactionId}` })
          } else {
            setTimeout(this.checkPay, 2000)
          }
        }
      })
    },
    submit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        console.log(values, err)
        if (err) {
          return;
        }
      if (this.value !== 'TMALL') {
        this.timeOut = false;
        this.visible = true;
        this.qrurl = null;
      }
      const paytype = this.value
        this.$store.dispatch('check/creatPayTrade', {
          payload: {
            ...values,
            tradeId: this.tradeId,
            payType: this.value
          },
          callback: (res) => {
            if (paytype !== 'TMALL' && res.error_code === '10000' && res.result.payUrl) {
              this.qrurl = res.result.payUrl;
              this.$refs.qrcode.innerHTML = '';
              this.creatQrCode()
              // this.$router.push({path:`/down?tradCode=${res.data.transactionId}`})
            } else if (res.error_code === '10000') {
              this.$router.push({ path: `/reports/${values.authcode}` })
            }
          }
        })
      })
    },
    couponSubmit (e) {
      e.preventDefault();
      this.couponform.validateFields((err, values) => {
        if (err) {
          return;
        }
        console.log(this.tradeId)
        this.$store.dispatch('check/redeemCoupon', {
          payload: {
            ...values,
            tradeId: this.tradeId,
          },
          callback: (res) => {
            if (res.success) {
              message.success("优惠券兑换成功！")
              // this.useCoupon = true;
              // this.couponPrice = res.data.couponPrice;
              // //this.cashFee = res.data.cashFee;
              // this.afterConponAmount = res.data.cashFee
              this.$store.dispatch('check/getTradeById', {
                payload: {
                  tradeId: this.tradeId,
                },
                callback: (res) => {
                  this.result = [res]
                }
              })
            }
          }
        })
      })
    },
  },
};
</script>

<style scoped>
.ck-content {
  margin: 20px auto;
}

.submit-cont .level-verisons {
  margin-bottom: 20px;
  margin-left: -17px;
}
.submit-cont .level-verisons .version-item {
  float: left;
  width: 240px;
  margin-left: 17px;
  max-width: 280px;
  height: 80px;
  text-align: center;
  color: #898989;
  cursor: pointer;
  position: relative;
  padding: 1px;
  background-color: #dfdfdf;
  margin-bottom: 8px;
}
.submit-cont .level-verisons .version-item.active,
.submit-cont .level-verisons .version-item:hover {
  border: none;
  background: #0c368a;
  background: -moz-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: -webkit-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: -o-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: -ms-linear-gradient(left, #0c368a 0, #1b99cf 100%);
  background: linear-gradient(to right, #0c368a 0, #1b99cf 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#0c368a, endColorstr=#1b99cf, GradientType=1);
}
.submit-cont > .ant-row-flex > .ant-col {
  background-color: #fff;
  padding: 25px 20px;
  border-right: 1px solid #ebebeb;
  width: 73%;
}
.submit-cont .level-verisons .version-item .v-name {
  height: 45px;
  line-height: 45px;
  background-color: #fff;
  font-size: 18px;
}
.submit-cont .level-verisons .version-item.active .v-name,
.submit-cont .level-verisons .version-item:hover .v-name {
  color: #0c368a;
}
.submit-cont .level-verisons .version-item.active .icon-check,
.submit-cont .level-verisons .version-item:hover .icon-check {
  display: block;
}

.submit-cont .level-verisons .version-item .icon-check {
  display: none;
  position: absolute;
  right: -1px;
  top: -1px;
}
.submit-cont .level-verisons .version-item.active .v-foot,
.submit-cont .level-verisons .version-item:hover .v-foot {
  background-color: transparent;
  color: #fff;
}

.submit-cont .level-verisons .version-item .v-foot {
  height: 33px;
  line-height: 33px;
  background-color: #f5f5f5;
}
.cb-list li {
  line-height: 2;
}
.cb-list .igou {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 17px;
  margin-top: -4px;
  margin-right: 16px;
  background: url(../assets/images/goucheck.png) no-repeat center;
}
.ant-radio-group {
  width: 100%;
}
</style>
